export default __webpack_public_path__ + "static/media/julian.a2da7a58.png";